import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { ClipboardTextIcon } from '@rsos/assets/icons';
import { Box, Button } from '@rsos/components/capstone/base';
import { toggleResourcePanel } from '@rsos/reduxDataStore/src/features/resourceRequests';

/**
 * Navigation button for opening the Resource Request Panel.
 * Displays a clipboard icon and toggles the resource panel visibility when clicked.
 */
export const ResourceRequestBtn: FunctionComponent = () => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(toggleResourcePanel());
  };

  return (
    <Box horizontal onClick={handleClick}>
      <Button
        btnType="tertiary"
        size="small"
        type="button"
        dataName="resource-request-nav-button"
        aria-label="Request Resources"
      >
        <ClipboardTextIcon width={16} height={16} />
      </Button>
    </Box>
  );
};

export default ResourceRequestBtn;
